﻿
window.setUpInteractiveMap = function () {

	var map = document.querySelector('.at-a-glance__map-wrapper svg');
	var mapHome = document.querySelector('.at-a-glance__map-wrapper');
	var container = document.querySelector('.at-a-glance--interactive');

	//viewBoxes
	var defaultViewBox = "0 0 455 675";
	var scotlandViewBox = "121 114 195 270";//"121 114 195 270";
	var northViewBox = "217 250 177 212";//"207 230 195 270";
	var southViewBox = "210 378 246 260";//"210 378 195 270"

	if (map != null) {

		// labels
		var lblScotland = Array.prototype.slice.call(document.querySelectorAll('.scotland-area'));
		var lblNorth = Array.prototype.slice.call(document.querySelectorAll('.north-area'));
		var lblSouth = Array.prototype.slice.call(document.querySelectorAll('.south-area'));

		// map areas
		lblScotland.push(document.getElementById("Scotland1"));
		lblScotland.push(document.getElementById("Scotland2"));
		lblScotland.push(document.getElementById("Scotland3"));
		lblNorth.push(document.getElementById("North1"));
		lblNorth.push(document.getElementById("North2"));
		lblNorth.push(document.getElementById("North3"));
		lblSouth.push(document.getElementById("South"));

		// pop-overs
		var popoverScotland = document.querySelectorAll('.at-a-glance__popover--scotland')[0];
		var popoverNorth = document.querySelectorAll('.at-a-glance__popover--north')[0];
		var popoverSouth = document.querySelectorAll('.at-a-glance__popover--south')[0];

		// close buttons
		var closeButtons = document.querySelectorAll('.close-popover');

		// keep track of the active popover
		var activePop = null;


		// add click events to the lables and map areas to open the popover...

		// Scotland
		lblScotland.forEach(function (lbl) {
			lbl.addEventListener('click', function () {
				showPop(popoverScotland, scotlandViewBox);
			})
		});

		// North
		lblNorth.forEach(function (lbl) {
			lbl.addEventListener('click', function () {
				showPop(popoverNorth, northViewBox);
			})
		});

		// South
		lblSouth.forEach(function (lbl) {
			lbl.addEventListener('click', function () {
				showPop(popoverSouth, southViewBox);
			})
		});

		// close button click events
		closeButtons.forEach(function (btn) {
			btn.addEventListener('click', function () {
				hidePop();
			})
		});
	}

	function showPop(el, viewBox) {
		activePop = el;

		// change the map viewBox
		map.setAttribute("viewBox", viewBox);

		// move the map in to the pop-over - yes, really!
		var placeholder = activePop.querySelector('.at-a-glance__popover__map-wrapper');

		placeholder.appendChild(map);

		activePop.classList.add('show');
		container.classList.add('showing-pop');

		// scroll only on small screens
		if (window.innerWidth < 800) {
			el.scrollIntoView();
		}
    }

	function hidePop() {
		if (activePop != null) {

			// revert the viewBox back to default
			map.setAttribute("viewBox", defaultViewBox);

			// move the map back to the main view
			var activeMap = activePop.querySelector('.at-a-glance__popover__map-wrapper svg');

			 mapHome.appendChild(activeMap);

			activePop.classList.remove('show');
			container.classList.remove('showing-pop');

			activePop = null;
		}
	}
}

if (document.readyState !== 'loading') {
	window.setUpInteractiveMap();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.setUpInteractiveMap();
	});
}